import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { noop } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel } from '@zep/ui';
import { TossPaymentsWidgetProvider, TossPaymentsWidgetProviderProps, useTossPaymentsWidget } from '../PlanPaymentSection/Providers';
const Content = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    visible,
    remove
  } = useModal();
  const {
    isWidgetReady,
    handleClickOnetimePayment
  } = useTossPaymentsWidget();
  const handleClick = () => {
    handleClickOnetimePayment();
  };
  return <Dialog open={visible} onClose={noop} maxWidth={'640px'} data-sentry-element="Dialog" data-sentry-component="Content" data-sentry-source-file="TossWidgetModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="TossWidgetModal.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="TossWidgetModal.tsx">
        <DialogHeader onClose={remove} data-sentry-element="DialogHeader" data-sentry-source-file="TossWidgetModal.tsx">
          <h2 className="text-[17px] font-[700] text-gray-900">
            {t('subscription:payment.paymentMethod.subTitle', '결제 수단')}
          </h2>
        </DialogHeader>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="TossWidgetModal.tsx">
          <div className="w-full">
            <div id={PAYMENT_METHOD_SELECTOR} />
          </div>
        </DialogContent>
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="TossWidgetModal.tsx">
          <Button onClick={handleClick} disabled={!isWidgetReady} data-sentry-element="Button" data-sentry-source-file="TossWidgetModal.tsx">
            {t('subscription:payment.tossWidget.methodSelected', '선택 완료')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
const _TossWidgetModal = (props: TossPaymentsWidgetProviderProps) => {
  return <TossPaymentsWidgetProvider {...props} data-sentry-element="TossPaymentsWidgetProvider" data-sentry-component="_TossWidgetModal" data-sentry-source-file="TossWidgetModal.tsx">
      <Content data-sentry-element="Content" data-sentry-source-file="TossWidgetModal.tsx" />
    </TossPaymentsWidgetProvider>;
};
export const TossWidgetModal = NiceModal.create(_TossWidgetModal);
export const PAYMENT_METHOD_SELECTOR = 'payment-method';